module.exports = __webpack_public_path__ + "static/media/approval.5816829d.svg";